import { darkStyles } from 'react-json-view-lite';

export const TreatmentDefaultColors = {
  Control: '#E8E8E8',
  A: '#A29BFE',
  B: '#4FC3F7',
  C: '#F3B1CD',
  D: '#58B19F',
  E: '#656F94',
  F: '#EFC6FC',
  G: '#F0D5BA',
  H: '#A6868F',
  I: '#0D47A1',
  J: '#BAD5F0',
  K: '#EDAB9B',
  L: '#4834D4',
  M: '#95AFC0',
  N: '#82589F',
  O: '#0288D1',
};
export const TreatmentIds = [
  'Control', // 'Control' is the default treatment id, and it is not allowed to be changed.
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
];

export const TimeSliceTimeUnit = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

export const CustomJsonLiteStyles = {
  ...darkStyles,
  container: 'dark',
  label: 'label',
  stringValue: 'string',
  numberValue: 'number',
  booleanValue: 'boolean',
  nullValue: 'null',
  punctuation: 'punctuation',
  undefined: 'undefined',
};

export const PopulationTargetMode = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
};

export const PopulationTargetType = {
  CITY: 'city',
  COUNTRY: 'ctry',
  REGIONAL: 'reg',
};

export const PopulationTargetName = {
  [PopulationTargetType.CITY]: 'City',
  [PopulationTargetType.COUNTRY]: 'Country',
  [PopulationTargetType.REGIONAL]: 'Regional',
};

export const VariableType = {
  STRING: 'string',
  INT64: 'int64',
  FLOAT64: 'float64',
  BOOLEAN: 'boolean',
  JSON: 'json',
  MAP: 'map',
};

export const ExperimentAssignmentStrategy = {
  UNIFORM_CHOICE: 'uniformChoice',
  WEIGHTED_CHOICE: 'weightedChoice',
  EXPLICIT_GROUP: 'explicitGroup',
  GEO_TIME_SLICE_SHUFFLE: 'geoTimeSliceShuffle',
  TIME_SLICE: 'timeSlice',
  TIME_SLICE_V2: 'timeSliceV2',
  CUSTOM_TIME_SLICE: 'customTimeSlice',
  TIME_SLICE_SHUFFLE: 'timeSliceShuffle',
  TIME_SLICE_GROUPED: 'timeSliceGrouped',
  EXPLICIT_RANGE: 'explicitRange',
};

export const CustomTimeSliceStrategy = {
  BALANCED_SHUFFLE: 'BalancedShuffle',
};

export const ExpFormField = {
  NAME: 'name',
  OWNER: 'owner',
  DESCRIPTION: 'description',
  DOMAIN: 'domain',
  OVERLAP_BY_DEFAULT: 'overlapByDefault',
  PRODUCT_MANAGER: 'productManager',
  PRODUCT_ANALYST: 'productAnalyst',
  VARIABLES: {
    ROOT: 'variables',
    DETAIL: (variableName) => ['variables', variableName],
    TREATMENT_VALUE: (variableName, treatmentId) => [
      'variables',
      variableName,
      treatmentId,
    ],
  },
  STRATEGY: {
    ROOT: 'strategy',
    NAME: ['strategy', 'name'],
    CUSTOM_TIME_SLICE_STRATEGY_NAME: [
      'strategy',
      'customTimeSliceStrategy',
      'name',
    ],
    CUSTOM_TIME_SLICE_STRATEGY_DURATION: [
      'strategy',
      'customTimeSliceStrategy',
      'duration',
    ],
    CUSTOM_TIME_SLICE_STRATEGY_DAY_LENGTH: [
      'strategy',
      'customTimeSliceStrategy',
      'dayLength',
    ],
    ALL_VALUES: ['strategy', 'values'],
    TREATMENT_VALUE: (treatmentId) => ['strategy', 'values', treatmentId],
    TIME_VALUE: (treatmentId) => [
      'strategy',
      'values',
      treatmentId,
      'time',
      'value',
    ],
    TIME_TYPE: ['strategy', 'time', 'type'],
    BUFFER_VALUE: (treatmentId) => [
      'strategy',
      'values',
      treatmentId,
      'buffer',
      'value',
    ],
    BUFFER_TYPE: ['strategy', 'buffer', 'type'],
    GROUP: (treatmentId) => ['strategy', 'values', treatmentId, 'group'],
    GEO_REGION: ['strategy', 'geoRegion'],
    GEO_HASH: ['strategy', 'geohash'],
  },
  TARGET: {
    ROOT: 'target',
    MODE: ['target', 'mode'],
    TYPE: ['target', 'type'],
    VALUE: ['target', 'value'],
    GROUP: ['target', 'group'],
  },
  START: 'start',
  END: 'end',
  SAMPLE_SIZE: 'sampleSize',
  CONSTRAINTS: 'constraints',
  ANALYSIS_V2: 'analysis_v2',
};

export const SELECTED_EXPERIMENT_LS_KEY = 'selectedExperiment';

export const EXPERIMENT_FILTER_QUERY_SS_KEY = 'experimentFilterQuery';

export const BALANCED_SHUFFLE_TIME_SLICE_MAX_TREATMENTS = 3;
